module.exports = __webpack_public_path__ + "images/cq5fc.21a1.png";